import {InfoCircleOutlined, CaretRightOutlined} from "@ant-design/icons";
import {Button, Modal} from "antd";
import React, {useState} from "react";
import {useCodPaymentMethodSelection} from "../../../../../hooks/useCodPaymentMethodSelection";
import {CodPaymentMethodSelectionForm} from "../codPaymentMethodSelectionForm/CodPaymentMethodSelectionForm";
import {DocumentModal} from "../../../../documents/documentModal";
import {
    Wrapper,
    InfoContainer,
    InfoItem,
    InfoHeader,
    InfoValue,
    ActionButton
} from "./CustomerCodAggrementBlock.styles";
import {ContractDetails} from "../customerAccountingDetailInfo/CustomerAccountingDetailInfo.styles";
import {CustomButton} from "../../../../_defaultComponents/CustomButton/CustomButton";
import ContratCalculator from "../../../../../public/images/contract-calculator.svg";

export const CustomerCodAggrementBlock = ({
    codCommissionRate,
    isBackoffice = false,
    externalRecall
}) => {
    const [recall, setRecall] = useState(false);
    const {
        subCompaniesResults,
        canCodPaymentMethodSelectionSubcompanies,
        canShowCodPaymentMethodSelection,
        alreadyHasCoDPaymentContractSubcompanies,
        generateCoDPaymentContract,
        getCoDPaymentContract,
        contractLoading
    } = useCodPaymentMethodSelection({
        initialCall: true,
        initialData: [],
        dependencies: [recall, externalRecall],
        isBackoffice: isBackoffice
    });
    const [open, setOpen] = useState(false);
    const [codContractModalVisibility, setCodContractModalVisibility] = useState(false);
    const [codContractUrl, setCodContractUrl] = useState("");

    const openCodContractModal = async () => {
        const subCompanyId = alreadyHasCoDPaymentContractSubcompanies?.[0]?._id;
        const contractResult = await getCoDPaymentContract({
            subCompanyId
        });
        if (contractResult?.success) {
            setCodContractUrl(
                contractResult?.uploadedDocumentPath || contractResult?.contractPath || ""
            );
            setCodContractModalVisibility(true);
        }
    };

    return (
        <Wrapper>
            <InfoContainer>
                {!canShowCodPaymentMethodSelection && (
                    <>
                        <InfoItem>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%"
                                }}
                            >
                                <InfoHeader>
                                    <img src={ContratCalculator} alt="contract calculator icon" />
                                    <b>Güncel POS Komisyonu</b>
                                </InfoHeader>
                            </div>
                        </InfoItem>
                    </>
                )}
                {!canShowCodPaymentMethodSelection && (
                    <InfoItem>
                        <ContractDetails
                            style={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <InfoValue
                                style={{fontSize: "16px", fontWeight: "bold", color: "#389e0d"}}
                            >
                                {codCommissionRate != null
                                    ? `Haftalık % ${codCommissionRate} `
                                    : "-"}
                            </InfoValue>

                            {alreadyHasCoDPaymentContractSubcompanies?.length > 0 && (
                                <CustomButton
                                    onClick={openCodContractModal}
                                    className="all-contracts-btn"
                                    style={{marginRight: "0px"}}
                                >
                                    Sözleşmeyi Görüntüle
                                    <CaretRightOutlined />
                                </CustomButton>
                            )}
                        </ContractDetails>
                    </InfoItem>
                )}
            </InfoContainer>

            <DocumentModal
                visibility={codContractModalVisibility}
                onCancel={() => setCodContractModalVisibility(false)}
                documentUrl={codContractUrl}
                title="Kapıda Ödeme Sözleşmesi"
                isNeedForApproval={false}
                description={
                    <p style={{fontSize: "16px", textAlign: "left", lineHeight: "1.8"}}>
                        Sözleşmenin bir kopyasını bir hafta içerisinde ıslak imzalı olarak Vigo
                        Merkez Ofise göndermelisiniz.
                    </p>
                }
            />
        </Wrapper>
    );
};
